(function() {
  define('bazemont/event/edit',['angular', 'angularAnimate', 'angularBootstrap'], function() {
    'use strict';
    return angular.module('bazemontEventEdit', ['ngAnimate', 'ui.bootstrap']).component('bazemontEventEdit', {
      template: '<a href="" ng-click="$ctrl.openModal()" ng-transclude></span>',
      transclude: true,
      bindings: {
        event: '=?',
        forbidPastEvents: '<'
      },
      controller: [
        '$http', '$uibModal', 'TlhNotifierService', 'BazemontEvents', function($http, $uibModal, TlhNotifierService, BazemontEvents) {
          var vm;
          vm = this;
          vm.$onInit = function() {
            vm.newEvent = !vm.event;
            return vm.event != null ? vm.event : vm.event = {
              isActive: true
            };
          };
          vm.openModal = function() {
            var modal;
            modal = $uibModal.open({
              templateUrl: '/assets/javascripts/bazemont/event/edit.html',
              controllerAs: '$ctrl',
              bindToController: true,
              resolve: {
                data: {
                  event: vm.event
                }
              },
              controller: [
                '$http', '$uibModalInstance', '$scope', 'data', 'TlhDateService', function($http, $uibModalInstance, $scope, data, TlhDateService) {
                  var endsBeforeStart, getFormError, handleDateChange, mvm, preselectEventCategory, setDatepickersOptions, validateForm, validateRecipients;
                  mvm = this;
                  preselectEventCategory = function() {
                    var category, _i, _len, _ref, _results;
                    if (mvm.categories.length > 1) {
                      if (mvm.event && mvm.event.category) {
                        _ref = mvm.categories;
                        _results = [];
                        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                          category = _ref[_i];
                          if (category.id === mvm.event.category.id) {
                            mvm.event.category = category;
                            break;
                          } else {
                            _results.push(void 0);
                          }
                        }
                        return _results;
                      }
                    } else if (mvm.categories.length === 1) {
                      return mvm.event.category = mvm.categories[0];
                    }
                  };
                  mvm.event = angular.copy(data.event);
                  $http.get('/api/user-categories', {
                    cache: true
                  }).then(function(response) {
                    mvm.categories = response.data.categories;
                    mvm.isAdmin = response.data.isAdmin;
                    return preselectEventCategory();
                  });
                  getFormError = function(event) {
                    var error;
                    error = null;
                    if (!event.eventDate) {
                      error = 'Veuillez sélectionner la date de l\'évènement';
                    } else if (!event.dateLabel) {
                      error = 'Veuillez saisir le libellé de la date';
                    } else if (!event.title) {
                      error = 'Veuillez saisir titre de l\'évènement';
                    }
                    return error;
                  };
                  validateForm = function() {
                    mvm.form.endsOn.$setValidity('endsBeforeStart', !endsBeforeStart(mvm.event.eventDate, mvm.event.endsOn));
                    return mvm.form.registrationRecipients.$setValidity('format', validateRecipients(mvm.event.registrationRecipients));
                  };
                  endsBeforeStart = function(start, end) {
                    return start && end && new Date(end).getTime() < new Date(start).getTime();
                  };
                  validateRecipients = function(recipients) {
                    var isValid, recipient, regex, _i, _len, _ref;
                    isValid = true;
                    if (!mvm.event.hasRegistration) {
                      mvm.event.registrationRecipients = '';
                      mvm.event.registrationMessage = '';
                    } else if (recipients) {
                      regex = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,25})$/;
                      _ref = recipients.split(',');
                      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                        recipient = _ref[_i];
                        if (!regex.test(recipient.trim())) {
                          isValid = false;
                          break;
                        }
                      }
                    }
                    return isValid;
                  };
                  mvm.submit = function() {
                    validateForm();
                    if (mvm.form.$valid) {
                      if (mvm.event.eventDate) {
                        mvm.event.eventDate = new Date(mvm.event.eventDate).getTime();
                      }
                      if (mvm.event.endsOn) {
                        mvm.event.endsOn = new Date(mvm.event.endsOn).getTime();
                      }
                      return $uibModalInstance.close(mvm.event);
                    }
                  };
                  mvm.close = function() {
                    return $uibModalInstance.dismiss();
                  };
                  setDatepickersOptions = function() {
                    var endsOnDate, endsOnMinDate, eventDate, eventDateMinDate;
                    eventDate = mvm.event.eventDate ? new Date(mvm.event.eventDate) : null;
                    endsOnMinDate = eventDate ? eventDate : vm.forbidPastEvents ? new Date() : null;
                    mvm.endsOnDatepickerOptions = {
                      minDate: endsOnMinDate,
                      initDate: endsOnMinDate
                    };
                    endsOnDate = mvm.event.endsOn ? new Date(mvm.event.endsOn) : null;
                    eventDateMinDate = vm.forbidPastEvents ? new Date() : null;
                    return mvm.eventDatepickerOptions = {
                      minDate: eventDateMinDate,
                      maxDate: endsOnDate,
                      initDate: endsOnDate
                    };
                  };
                  setDatepickersOptions();
                  handleDateChange = function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                      setDatepickersOptions();
                      return mvm.event.dateLabel = TlhDateService.getDateLabel(mvm.event.eventDate, mvm.event.endsOn);
                    }
                  };
                  $scope.$watch(function() {
                    return mvm.event.eventDate;
                  }, handleDateChange);
                  $scope.$watch(function() {
                    return mvm.event.endsOn;
                  }, handleDateChange);
                }
              ]
            });
            return modal.result.then(function(event) {
              if (vm.newEvent) {
                return TlhNotifierService.send(BazemontEvents.NEW_EVENT, event);
              } else {
                return TlhNotifierService.send(BazemontEvents.EDIT_EVENT, {
                  editedEvent: event,
                  currentEvent: vm.event
                });
              }
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=edit.js.map
;
